import {
  AfterViewInit,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { UserLoginService } from '../../../shared/services/user-login.service';
import { CognitoUtil } from '../../../shared/utils/cognito.service';
import { Router } from '@angular/router';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { SiteManagementService } from 'src/app/site-management/site-management.service';
import { LoaderService } from 'src/app/shared/utils/loader.service';
import { HelperService } from 'src/app/shared/utils/helper.service';
import { AccountSettingsComponent } from '../account-settings/account-settings.component';
import {
  IUser,
  IUserProfile,
} from 'src/app/user-management/user-management-interfaces';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import LoginRoutingPath from 'src/app/login/login-routing-path';
import { AccountSettingsService } from '../account-settings/account-setting.service';
import { StateManagementService } from 'src/app/shared/services/state-management.service';
import { UserProfileComponent } from 'src/app/user-management/user-profile/user-profile.component';
import { BRANDS } from 'src/app/shared/models/screen-size.enum';
import { SupportModalComponent } from '../support/support-modal/support-modal.component';

@Component({
  selector: 'app-main-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.scss'],
})
export class MainHeaderComponent implements OnInit, AfterViewInit, OnDestroy {
  subscription: Subscription | undefined;
  sharedData: any;
  CONSTANTS = CONSTANTS;
  profileImageSrc: any = 'assets/images/portrait-happy.jpg';
  readonly LANG_CONST = LANG_CONST;
  navLogo: string = CONSTANTS.KWIKSET_UNITE_LOGO;

  @Input() siteItem: any[] = [];
  @Input() profileDetails!: IUserProfile;
  @Input() user!: Observable<IUser | undefined>;
  constructor(
    private router: Router,
    public userService: UserLoginService,
    public cognitoUtil: CognitoUtil,
    public sharedDataService: SharedDataService,
    private siteManagementService: SiteManagementService,
    private loaderService: LoaderService,
    private helperService: HelperService,
    private accountSettingService: AccountSettingsService,
    private stateManagementService: StateManagementService
  ) {}

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {
    this.subscription = this.sharedDataService.currentData.subscribe(
      (sharedData) => {
        this.sharedData = sharedData;
      }
    );
    this.setImageByBrand();
  }

  setImageByBrand(): void {
    const brandName = this.stateManagementService.getUserBrand();
    this.navLogo =
      brandName === BRANDS.KWIKSETUNITE
        ? CONSTANTS.KWIKSET_UNITE_LOGO
        : CONSTANTS.WEISER_UNITE_LOGO;
  }

  ngAfterViewInit(): void {
    const URL = window.location.pathname;
    if (URL.includes('dashboard'))
      this.sharedDataService.setHeaderTab(CONSTANTS.DASHBOARD);
    else if (URL.includes('site-management'))
      this.sharedDataService.setHeaderTab(CONSTANTS.LOCATIONS);
    else if (URL.includes('users'))
      this.sharedDataService.setHeaderTab(CONSTANTS.USERS);
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  logout() {
    this.loaderService.show();
    this.sharedDataService.resetSharedData();
    this.userService.logout().subscribe({
      next: () => {
        this.loaderService.hide();
      },
      error: () => {
        this.loaderService.hide();
      },
    });
  }

  onSelected(selected: string) {
    this.sharedDataService.setHeaderTab(selected);
  }
  viewAccountSetting(): void {
    const dialogInstance = this.helperService.openModalDialog(
      AccountSettingsComponent,
      { enableBackOperation: false, defaultNavigation: CONSTANTS.BUILDING },
      [CONSTANTS.FIXED_SCREEN_MODAL, CONSTANTS.SPACE_ZERO]
    );
  }

  /**
   * @description: this function is to redirect user profile view modal.
   * @returns void
   */

  viewUserProfile(): void {
    const dialogInstance = this.helperService.openModalDialog(
      UserProfileComponent,
      {
        enableBackOperation: false,
        defaultNavigation: CONSTANTS.BUILDING,
        profileDetails: this.profileDetails,
        ownProfile: true,
        userId: this.stateManagementService.getUser().userId,
        siteTimeZone: this.sharedData?.selectedSite?.siteTimeZone,
      },
      [CONSTANTS.FIXED_SCREEN_MODAL, CONSTANTS.SPACE_ZERO]
    );
  }
  helpFaqs(): void {
    const brand = this.stateManagementService?.getUserBrand();
    const Lang = this.stateManagementService?.getUserLanguage();
    if (brand === BRANDS.WEISER) {
      if (Lang === LANG_CONST.FRENCH) {
        window.open(CONSTANTS.HELP_LINK_FRENCH_WEISER, '_blank');
      } else {
        window.open(CONSTANTS.HELP_LINK_WEISER, '_blank');
      }
    } else {
      window.open(CONSTANTS.HELP_AND_FAQ_LINK, '_blank');
    }
  }

  openSupport(): void {
    this.helperService.openModalDialog(
      SupportModalComponent,
      null,
      CONSTANTS.SITE_SETTINGS_MODAL
    );
  }
}
